var map = {
	"./ACM1.png": 9235,
	"./ACM2.png": 4386,
	"./Ching.jpg": 4096,
	"./Chu Vn To.jpg": 5836,
	"./Griffith_University_logo.png": 3750,
	"./HSIA.png": 7131,
	"./ICS_stacked-transparent.gif": 5454,
	"./IEEE_VN_Logo_Rect.jpg": 293,
	"./IEEE_logo.jpg": 1231,
	"./IKEEE.jpg": 7409,
	"./ITO.jpg": 172,
	"./Ishida.png": 8838,
	"./KHTN.png": 7383,
	"./Michela Taufer.jpg": 4004,
	"./NSF_4-Color_bitmap_Logo.png": 2151,
	"./Nguyen-Toan-2.png": 7873,
	"./Ono2010.jpg": 3530,
	"./STCLogo1.png": 9025,
	"./STC_CloudComputing.png": 2662,
	"./Tania Lorido Botran.jpg": 2851,
	"./Weisong Shi.jpg": 1903,
	"./campus-entrance-fall.jpg": 12,
	"./campus-entrance-fall.png": 709,
	"./clients-01.svg": 8314,
	"./clients-02.svg": 5170,
	"./clients-03.svg": 8076,
	"./clients-04.svg": 2750,
	"./clients-05.svg": 571,
	"./cloudbuslogo.png": 9171,
	"./cta-illustration.svg": 4161,
	"./dzungdao.jpg": 1603,
	"./feature-tile-icon-01.svg": 835,
	"./feature-tile-icon-02.svg": 5664,
	"./feature-tile-icon-03.svg": 7349,
	"./feature-tile-icon-04.svg": 4579,
	"./feature-tile-icon-05.svg": 8081,
	"./feature-tile-icon-06.svg": 2634,
	"./features-split-icon.svg": 6691,
	"./features-split-image.svg": 9458,
	"./features-split-top-01.png": 6720,
	"./features-split-top-02.png": 1061,
	"./features-split-top-03.png": 1923,
	"./frame-icon.svg": 1660,
	"./header.JPG": 9821,
	"./hero-image.svg": 9970,
	"./hotel/Equatorial.jpg": 9015,
	"./hotel/Equatorial1.jpg": 3185,
	"./hotel/Equatorial2.webp": 5968,
	"./hotel/Equatorial3.jpg": 2159,
	"./hotel/Equatorial4.jpg": 5048,
	"./hotel/ngochung1.jpg": 1984,
	"./hotel/ngochung2.jpg": 5937,
	"./hotel/ngochung3.jpg": 9472,
	"./hotel/pt1.jpg": 4068,
	"./hotel/pt2.jpg": 5449,
	"./hotel/pt3.jpg": 6577,
	"./hotel/pt4.jpg": 7481,
	"./hotel/senviet.jpg": 4406,
	"./hotel/senviet1.webp": 8614,
	"./hotel/senviet2.webp": 4782,
	"./hotel/senviet3.webp": 4301,
	"./hotel/senviet4.webp": 1119,
	"./hotel/senviet5.webp": 8793,
	"./hotel/sgvl1.png": 860,
	"./hotel/sgvl2.jpg": 3161,
	"./hotel/sgvl3.jpg": 106,
	"./hotel/sgvl4.jpg": 4314,
	"./hotel/sgvl5.jpg": 6094,
	"./hotel/tanhoanglong.jpg": 9950,
	"./hotel/tanhoanglong1.webp": 7205,
	"./hotel/tanhoanglong2.webp": 5961,
	"./hotel/tanhoanglong3.webp": 1586,
	"./hotel/tanhoanglong4.webp": 419,
	"./huuduc.jpg": 2336,
	"./ieej-logo-b.jpg": 9123,
	"./illustration-element-01-top.svg": 8099,
	"./illustration-element-01.svg": 2389,
	"./illustration-element-02-top.svg": 9956,
	"./illustration-element-02.svg": 7980,
	"./illustration-element-03.svg": 7227,
	"./illustration-element-04.svg": 2141,
	"./illustration-element-05.svg": 1710,
	"./illustration-element-06.svg": 6349,
	"./illustration-element-07.svg": 5295,
	"./illustration-element-08.svg": 7555,
	"./illustration-section-01.svg": 3929,
	"./illustration-section-02.svg": 609,
	"./illustration-section-03.svg": 1126,
	"./illustration-section-04.svg": 3346,
	"./illustration-section-05.svg": 9866,
	"./illustration-section-06.svg": 9944,
	"./image-placeholder.png": 5992,
	"./janschulz.jpg": 7222,
	"./kookmin.png": 7988,
	"./kunyu.jpg": 6610,
	"./landing1.png": 3599,
	"./landing2.png": 8902,
	"./landing3.png": 5369,
	"./landing4.png": 417,
	"./logo.svg": 2835,
	"./mantis.jpg": 9264,
	"./masayatoda.jpg": 6295,
	"./member/Alan Sill.jpg": 3236,
	"./member/Alex Uta.jpg": 126,
	"./member/Auluck-Nitin.jpeg": 1883,
	"./member/Ben McCamish.jpg": 2799,
	"./member/Brian Larkins.jpg": 9035,
	"./member/David Chiu.jpg": 7954,
	"./member/Ganesh Neelakanta Iyer.jpg": 4231,
	"./member/Hohai University.png": 6835,
	"./member/Jianwu Wang.jpg": 2816,
	"./member/Josef Spillner.jpg": 1382,
	"./member/Kenneth Johnson.jpg": 2283,
	"./member/Luiz Bittencourt.jpg": 8139,
	"./member/Ngan Nguyen.jpg": 3481,
	"./member/North Texas.png": 9277,
	"./member/Pamela Delgado.jpg": 6993,
	"./member/Paolo Falcarin.jpg": 8658,
	"./member/Praveen Kumar Donta.png": 8074,
	"./member/Song Fu.jpg": 2589,
	"./member/Texas Tech.png": 9928,
	"./member/Tommy Dang.jpg": 4054,
	"./member/U of Campinas.png": 5265,
	"./member/U of Puget Sound.png": 5568,
	"./member/UMBC.png": 2438,
	"./member/WSU.png": 8954,
	"./member/Xinghui Zhao.jpg": 2848,
	"./member/Yan Tang.jpg": 7347,
	"./member/Zichuan Xu.jpg": 6157,
	"./member/ahmed-200x301.png": 5972,
	"./member/unknown.jpg": 9984,
	"./mtulogo.png": 6919,
	"./news-image-01.jpg": 180,
	"./news-image-02.jpg": 4493,
	"./news-image-03.jpg": 1775,
	"./orangebackground.webm": 7853,
	"./other/buoi.jpg": 2908,
	"./other/longan.jpg": 6987,
	"./other/mangthit.jpg": 7707,
	"./other/mangthit2.jpg": 9608,
	"./other/mangthit3.jpg": 9616,
	"./other/mangthit4.png": 3552,
	"./other/mangthit5.png": 733,
	"./other/mangthit6.png": 2294,
	"./other/mangthit7.jpg": 6354,
	"./other/mangthit8.jpg": 595,
	"./other/mangthit9.jpg": 3613,
	"./other/rambutan.jpg": 3305,
	"./other/snake.jpg": 7790,
	"./other/vl.png": 8428,
	"./other/vlf.jpg": 4604,
	"./paymentQR.jpg": 8787,
	"./phamtrung.jpg": 7003,
	"./redsun.jpg": 4992,
	"./semi.png": 484,
	"./sikmin.jpg": 1624,
	"./sonpsor-smater.jpg": 7597,
	"./tcsc-logo.gif": 1282,
	"./testimonial-image-01.jpg": 2642,
	"./testimonial-image-02.jpg": 4937,
	"./testimonial-image-03.jpg": 4719,
	"./tohoku-university-logo.png": 9204,
	"./trantrinang.jpg": 6126,
	"./trungpham.jpg": 6662,
	"./uol_logo.jpg": 7508,
	"./venue/MTU1.jpg": 4213,
	"./venue/MTU2.jpg": 4471,
	"./venue/MTU3.jpg": 4504,
	"./venue/MTU4.jpg": 6246,
	"./venue/inside1.jpg": 778,
	"./venue/inside2.jpg": 4805,
	"./venue/outside1.jpg": 3056,
	"./venue/outside1.png": 8784,
	"./venue/outside2.jpg": 5624,
	"./venueHolder.png": 6228,
	"./video-placeholder.svg": 1904,
	"./vinhpnguyen.jpg": 7516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;